import { render, staticRenderFns } from "./BdTableUniapp.vue?vue&type=template&id=6bf9de02&scoped=true&"
import script from "./BdTableUniapp.vue?vue&type=script&lang=js&"
export * from "./BdTableUniapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf9de02",
  null
  
)

export default component.exports